import { GCInstant, GCInstant as platform } from 'src/lib/gcinstant';
import { measureLoadPhase } from 'src/lib/analytics/gameLoadTracking';
import {
  getEntryData,
  isFirstEntry,
  isFirstEntryOfDay,
} from 'src/lib/platformUtils';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { getLaunchScene, isSceneEntered } from 'src/lib/stateUtils';
import * as Social from 'src/replicant/social';
import StateObserver, { now, user } from 'src/StateObserver';
import { hasGiftsMessages, isGiftsFeatureUnlocked } from '../gifts/helpers';
import { levelUpSequence } from '../level/level.sequence';
import {
  actionBlock,
  singleAction,
  createLaunchSequence,
} from './LaunchSequence';
import { getPet, isPetConfigured } from '../pet';
import { getTutorialController } from '../tutorial/TutorialController';
import {
  duoPopupMutex,
  startDuoInvitationReceivedSequence,
  startDuoResponseSequence,
} from '../duo/duo.sequence';
import {
  guessInstalledNativeAppPlatform,
  isNativePromoAvailable,
  shouldRemindNativeAppUpdate,
} from '../native/native.util';
import {
  getApplication,
  getUrlSearchParamValue,
  isPlatformGuest,
  withLoading,
} from 'src/lib/utils';
import {
  showUpdateAppReminder,
  startInstallAppRewardSequence,
  startInstallNativeSequence,
  startIncentivisedUpdateRewardSequence,
} from '../native/native.sequence';
import features from 'src/replicant/ruleset/features';
import { startInviteFriendsSequence } from '../social/social.sequence';
import statePromise from 'src/lib/statePromise';
import { petIdleSequence, renamePetSequence } from '../pet/pet.sequence';
import {
  promoGroupLaunchSequence,
  promoSequence,
} from '../promo/promo.sequence';
import { TOS_VERSION } from 'src/replicant/ruleset/tos';
import { shouldSkipPopupOnLaunchDuringPayment } from 'src/lib/iap/iap.util';
import { canClaimResubscriptionReward } from '../../replicant/chatbot/chatbot.getters';
import { onboardingReturning } from './onboarding.sequence';
import * as Pet from 'src/replicant/pet';
import { getCurrentPetState } from 'src/replicant/fate/fate.getters';
import { startMatch2 } from '../minigame/match2-timestep/match2.sequence';
import { areRacesAvailable } from 'src/replicant/match2/races/races.getters';
import { openRaceSequence } from '../minigame/match2-timestep/races/races.sequence';
import { hasValidSaveState } from 'src/replicant/match2/savestate/match2-savestate.getters';
import {
  match2FrenzyLaunch,
  openMatch2FrenzyIntroPopup,
} from '../minigame/match2-timestep/frenzy/match2-frenzy.sequence';
import {
  getMatch2FrenzyIntroLastSeen,
  isMatch2FrenzyEnabled,
  isMatch2FrenzyUnlocked,
} from 'src/replicant/match2/frenzy/match2-frenzy.getters';
import {
  magicLampsHasGameInProgress,
  magicLampsIsAvailable,
} from 'src/replicant/match2/magiclamps/magiclamps.getters';
import {
  magicLampsLaunch,
  magicLampsResume,
} from '../minigame/match2-timestep/magiclamps/magiclamps.sequence';
import { handleDeepLink } from './deepLinks';
import { isEditorMode } from '../minigame/match2-timestep/editor/editor.utils';
import { hideLoading, showLoading } from 'src/state/ui';
import { marketingEventsSequence } from 'src/game/airtable/marketing/marketing.sequence';
import { isPlatformNative } from 'src/lib/native/native.util';
import { captureGenericError } from 'src/lib/sentry';
import { openGiftsListPopup } from '../gifts/gifts.sequence';
import {
  isStreakBattleRoyaleActive,
  isStreakBattleRoyaleEnabled,
} from 'src/replicant/streakbattleroyale/streakbattleroyale.getters';
import { openStreakBattleRoyalePopup } from '../streakbattleroyale/streakbattleroyale.sequence';
import {
  resurrectionFiftyGemsReward,
  resurrectionHundredGemsReward,
  resurrectionMigrationGemsReward,
  resurrectionRewards,
} from 'src/replicant/resurrection/resurrection.ruleset';
import {
  hasResurrectionRewardToClaim,
  isReactivated,
} from 'src/replicant/resurrection/resurrection.getters';
import { devSettings } from 'src/lib/settings';
import { trackPinchConversion } from 'src/lib/analytics/events';
import * as Tutorial from 'src/replicant/tutorial';
import { getTutorialServices } from '../tutorial/services/TutorialServices';
import { puzzleCoinsAutoCompleteTutorials } from '../puzzlecoins/puzzlecoins.sequence';
import { loadRegionAssets } from '../minigame/match2-timestep/match2.assets';
import { initMatch2Tournament } from '../minigame/match2-timestep/tournament/match2-tournament.sequence';
import { superLollipopLaunch } from '../superLollipop/superLollipop.sequence';
import { isSuperLollipopAvailable } from 'src/replicant/superLollipop/superLollipop.getters';
import {
  isGuestMigration,
  promptLINELoginNew,
  shouldShowNewPromptLINELoginOnLaunch,
} from '../guest/guest.sequence';
import { resolvePendingPurchases } from '../iap/component/iap.api';
import { treasureExpressLaunch } from '../treasureExpress/treasureExpress.sequence';
import { isTreasureExpressAvailable } from 'src/replicant/treasureExpress/treasureExpress.getters';
import PNsManager from '../native/push.notifications';
import { handleExistingUserReferral } from '../social/social.utils';
import { homeShortcutLaunchSequence } from '../homeShortcut/homeShortcut.sequence';
import { isHomeShortcutAvailable } from '../homeShortcut/homeShortcut.utils';
import { rescueLevelLaunch } from '../rescueLevel/rescueLevel.sequence';
import { rescueLevelIsEnabled } from 'src/replicant/rescueLevel/rescueLevel.getters';
import {
  addFriendsV2LaunchSequence,
  isEnteringFromInviteV2,
} from '../friends/addFriendsV2.sequence';
import {
  friendRequestLaunchSequence,
  isEnteringFromFriendRequest,
} from '../friends/friends.sequences';
import {
  buddiesIsAvailable,
  buddiesIsLocked,
} from 'src/replicant/buddies/buddies.getters';
import { buddiesLaunchSequence } from '../buddies/buddies.sequence';
import { jankenLaunchSequence } from '../janken/janken.launch';
import i18n from 'src/lib/i18n/i18n';
import { cardsAutoOpenFirstTime } from '../cards/cards.sequence';
import {
  cardsIsEnteringFromShareLink,
  cardsOpenShareLinkFromEntry,
} from '../cards/cards.share.entry';
import { cardsShouldAutoOpenFirstTime } from 'src/replicant/cards/cards.getters';
import { dreamDriftOpen } from '../dreamDrift/dreamDrift.sequence';
import {
  dreamDriftIsAvailable,
  dreamDriftShouldAutoOpenCurrentEvent,
} from 'src/replicant/dreamDrift/dreamDrift.getters';
import { isDreamDriftEntry } from '../dreamDrift/dreamDrift.utils';
import {
  isStickersEntry,
  openStickersPopup,
} from '../stickers/stickers.sequence';
import { canShowStickerPopupOnLaunch } from 'src/replicant/stickers/stickers.getters';

let loadingFromSave = false;
let wasInviteTriggeredFromGiftsLaunch = false;

export const defaultLaunchSequence = createLaunchSequence([
  /**
   * Reset launch-scoped flags.
   */
  async () => {
    wasInviteTriggeredFromGiftsLaunch = false;
    return false;
  },

  /**
   * Start straight into the level editor, if in editor mode.
   */
  async () => {
    // Skip if not in development mode
    if (!isEditorMode()) {
      return false;
    }

    getApplication().screenManager.showScreen('minigame', {
      minigame: 'match2-editor',
    });

    return true;
  },

  /**
   * Cheats.
   */
  async () => {
    if (devSettings.get('keepPetHappy')) {
      await StateObserver.invoke.cheat_makePetHappy();
    }

    return false;
  },

  /**
   * Handle automatically adding referrer as a friend for existing users
   * on all non-first entries (in-game friends feature is now always enabled).
   * Skip for Add Friends V2 invites - let the V2 sequence handle the confirmation flow.
   */
  actionBlock({
    skip: () => isFirstEntry() || isEnteringFromInviteV2(),
    actions: [
      async () => {
        // Add referrer as a friend if not already friends
        handleExistingUserReferral();

        return false;
      },
    ],
  }),

  /**
   * Handle crossplay
   */
  actionBlock({
    skip: () =>
      !isNativePromoAvailable() ||
      guessInstalledNativeAppPlatform() === null ||
      shouldSkipPopupOnLaunchDuringPayment(),
    actions: [
      async () => {
        // Hide loading screen, so the popup can be shown.
        await platform.dismissLoadingScreenAsync({
          launchPath: 'default_crossplay',
        });

        // Show crossplay popup.
        await openPopupPromise('popupLoginCrossplay', {
          origin: 'launch',
          originFeature: 'launch',
        });

        // Player didn't redirect to native so continue with next action.
        return false;
      },
    ],
  }),

  actionBlock({
    enabled: () => shouldRemindNativeAppUpdate(),
    actions: [
      async () => {
        await platform.dismissLoadingScreenAsync({
          launchPath: 'default_update_app_reminder',
        });
        await showUpdateAppReminder('launch');
        return false;
      },
    ],
  }),

  /**
   * Load the initial scene.
   */
  actionBlock({
    actions: [
      async () => {
        // Auto fix uncompleted tutorials for puzzle coins, if needed.
        puzzleCoinsAutoCompleteTutorials();

        const scene = getLaunchScene();
        const petController = getPet();

        // Block the entire screen in advance in case there is a save state, to prevent
        // user taking any action before the save state is loaded and gameplay started.
        StateObserver.dispatch(showLoading());

        if (scene === 'bedroom') {
          await measureLoadPhase('sceneEnter', () =>
            petController.moveTo({ scene, location: 'bed' }, 0),
          );
          petController.appearance.setAction('sleep');
        } else {
          await measureLoadPhase('sceneEnter', () =>
            petController.moveTo({ scene, location: 'c' }, 0),
          );
        }

        // Resume match 2 gameplay if there is a valid save state.
        if (hasValidSaveState(user(), now())) {
          loadingFromSave = true;

          // Skip play popup for this session
          if (isPetConfigured()) {
            getPet().conversation.hasShownPlayMatch2InSession = true;
          }

          await new Promise<void>(
            (resolve) =>
              void startMatch2({
                onSceneEntered: async () => {
                  await platform.dismissLoadingScreenAsync({
                    launchPath: 'default_resume_match2',
                  });
                  resolve();
                },
              }),
          );
        }

        // Otherwise, dismiss the loading screen.
        else {
          // Resume magic lamps gameplay.
          if (magicLampsHasGameInProgress(user(), now())) {
            loadingFromSave = true;
            void magicLampsResume('launch');
          }

          await platform.dismissLoadingScreenAsync({
            launchPath: 'default_initial_scene',
          });
          // Start bgm once the scene is entered.
          sounds.music.playBackgroundMusic('bgm');
        }

        const { settings } = StateObserver.getState().user;
        sounds.musicMuted = !settings.music;
        sounds.sfxMuted = !settings.sound;

        // Hide the loading showed at the beginning of this action block
        StateObserver.dispatch(hideLoading());

        // Continue with next action.
        return false;
      },
    ],
  }),

  /**
   * Rewards for migrated guest
   */
  actionBlock({
    enabled: () => isGuestMigration(),
    actions: [
      async () => {
        // If user is a migrated guest, display the rewards they got from the migration.
        await openPopupPromise('popupLineGuestLoginReward', {});
        return false;
      },
    ],
  }),

  /**
   * LINE onboarding — recurring launch prompt.
   *
   * First entry is handled at the splash by `onboardingFirstEntry`, so the launch
   * sequence handles only returning users.
   */
  singleAction({
    skip: () =>
      isFirstEntry() || isPlatformGuest(platform) || isPlatformNative(),
    action: async () => {
      await onboardingReturning('launch_sequence');
      return false;
    },
  }),

  /**
   * Resubscribe reward.
   */
  actionBlock({
    skip: ({ user }) =>
      !canClaimResubscriptionReward(user, now()) ||
      !GCInstant.isSubscribedToBot,
    actions: [
      async () => {
        try {
          await StateObserver.invoke.claimResubscriptionReward();
          await openPopupPromise('popupResubscribeReward', {
            origin: 'launch',
          });
        } catch (e) {
          captureGenericError('claimResubscriptionReward', e);
        }
        return false;
      },
    ],
  }),

  /**
   * Initialize match2 tournament in background.
   */
  async () => {
    initMatch2Tournament();
    return false;
  },

  /**
   * Processes deep links.
   * Note: this is an action, returning true will end the sequence.
   */
  () => handleDeepLink(getEntryData().$deepLink),

  /**
   * Fulfill any post-redirect purchases
   */
  async () => {
    const { ui } = StateObserver.getState();

    // Fulfill pending payments.
    const result = await resolvePendingPurchases();

    // Make sure that we init pet scene correctly
    if (result.length > 0 && ui.transition.nextScene === 'livingRoom') {
      await statePromise(() => isSceneEntered('livingRoom'));
      await petIdleSequence();
    }

    // Skip whole next launch sequence on success
    return result.length > 0;
  },

  /**
   * Skip remaining default launch sequence when user is in payment flow, or if
   * user is in the middle of a match2 game that can be resumed (i.e. has a valid save state).
   * Note: this is an action, returning true will end the sequence.
   */
  async () => {
    // Check if should skip popup on launch during payment
    const skipPopup = shouldSkipPopupOnLaunchDuringPayment();

    // Otherwise, check if user can resume match2 gameplay
    const user = StateObserver.getState().user;

    // User is in the middle of a match2 game, go straight to gameplay
    if (loadingFromSave) {
      return true;
    }

    // Resume magic lamps gameplay.
    if (magicLampsHasGameInProgress(user, now())) {
      return magicLampsResume('launch');
    }

    return skipPopup;
  },

  /**
   * Go straight into match2 gameplay if a level param is set in the URL.
   * Only for development.
   */
  async () => {
    if (!process.env.IS_DEVELOPMENT) return false;
    if (!getUrlSearchParamValue('level')) return false;
    void startMatch2({
      onSceneEntered: () => {
        void platform.dismissLoadingScreenAsync({
          launchPath: 'development_match2_level',
        });
      },
    });
    return true;
  },

  /**
   * Trigger FTUX if needed.
   * Note: this is an action, returning true will end the sequence.
   */
  async () => {
    const started = await getTutorialController().handleEvent('gameStarted');

    const basicGameplay = Tutorial.getters.isTutorialStepComplete(
      user(),
      'basicGameplay',
    );
    const chatWithPets = Tutorial.getters.isTutorialStepComplete(
      user(),
      'chatWithPets',
    );

    // If enabled, show hand on pet during between basicGameplay and chatWithPets tutorials
    // So user can know that they should tap the pet to chat with it.
    if (basicGameplay && !chatWithPets) {
      const { hand } = getTutorialServices();
      hand.show({ tag: 'buruburu', x: 200, y: 200 });
    }

    return false;
  },

  /**
   * Check if ToS was updated, and show popup.
   */
  actionBlock({
    actions: [
      async () => {
        if (await platform.tos.hasAcceptedToS(TOS_VERSION)) return true;

        platform.tos.trackPopupOpenEvent(TOS_VERSION);

        const shownAt = StateObserver.now();

        await openPopupPromise('popupToSUpdated', { origin: 'launch' });

        platform.tos.acceptToS(TOS_VERSION, {
          requestMs: StateObserver.now() - shownAt,
        });

        return true;
      },
    ],
  }),

  actionBlock({
    enabled: () => cardsIsEnteringFromShareLink(),
    actions: [
      async () => {
        await cardsOpenShareLinkFromEntry('launch');
        return false;
      },
    ],
  }),

  /**
   * Claim pending referral rewards
   */
  actionBlock({
    enabled: ({ user }, now) =>
      Social.getters.hasPendingReferralRewards(user, now),
    actions: [
      async () => {
        await openPopupPromise('popupFriendJoinedReward', {
          ...Social.getters.getPendingReferralRewards(user()),
          origin: 'launch',
        });

        await StateObserver.invoke.referralClaimSuccessJoinedReward();
        trackPinchConversion({
          action: 'viral',
          feature: Feature.INVITE._,
          subFeature: Feature.INVITE.INVITE_FRIEND_JOINED_TO_GAME,
          resource: 'gems',
        });
        return false;
      },
    ],
  }),

  /**
   * Reward for native app installation
   */
  () => startInstallAppRewardSequence('launch'),

  /**
   * Reward for incentivised app update
   */
  () => startIncentivisedUpdateRewardSequence('launch'),

  /**
   * Marketing link rewards
   */
  () => marketingEventsSequence(),

  /**
   * Prompt the player to rename their pet if they didn't after obtaining
   * a new pet, or if it somehow otherwise doesn't have a valid name.
   */
  actionBlock({
    enabled: ({ user }) => !user.pet.name || !user.pet.nameUpdated,
    actions: [
      async () => {
        await renamePetSequence({ origin: 'launch' });

        // Continue with next action.
        return false;
      },
    ],
  }),

  /**
   * Show duo response received sequence.
   */
  async () => {
    const { user } = StateObserver.getState();

    // Duo not enabled, bail.
    if (!features(user).duo) return false;

    // No species, there's something wrong, bail.
    const species = Pet.getters.getEquippedPetSpecies(user);
    if (!species) {
      // Should just delete lastResponse and bail.
      await StateObserver.invoke.deleteLastDuoResponse();
      return false;
    }

    // Show any pending duo responses.
    return startDuoResponseSequence();
  },

  /**
   * Handle revive resurrection OA message reward.
   */
  actionBlock({
    enabled: ({ user }, now) =>
      hasResurrectionRewardToClaim(user, 'revivePet', now),
    actions: [
      async () => {
        // Claim the resurrection revival on backend
        await withLoading(StateObserver.invoke.claimResurrectionRevivePet, {
          feature: Feature.RESURRECTION._,
          subFeature: Feature.RESURRECTION.PET_REVIVAL,
        });

        // Show revived popup
        await openPopupPromise('popupRevivalSimple', {
          mode: 'revived',
          species: Pet.getters.getCurrentEvolution(user())?.species || 'ball',
          origin: 'launch',
        });

        // Continue with next action
        return false;
      },
    ],
  }),

  /**
   * Handle resurrection migration ToS OA message gems reward.
   */
  actionBlock({
    enabled: ({ user }, now) =>
      hasResurrectionRewardToClaim(user, 'migrationGems', now),
    actions: [
      async () => {
        // Show reward granting popup
        await openPopupPromise('popupMatch2GrantRewards', {
          rewards: [resurrectionMigrationGemsReward],
          title: 'resurrection.welcomeBack',
          origin: 'launch',
        });

        // Claim the resurrection migration ToS gems on backend
        await StateObserver.invoke.claimResurrectionMigrationGems();

        // Continue with next action
        return false;
      },
    ],
  }),

  /**
   * Handle gems resurrection OA message reward.
   */
  actionBlock({
    enabled: ({ user }, now) =>
      hasResurrectionRewardToClaim(user, 'hundredGems', now),
    actions: [
      async () => {
        // Show reward granting popup
        await openPopupPromise('popupMatch2GrantRewards', {
          rewards: [resurrectionHundredGemsReward],
          title: 'resurrection.welcomeBack',
          origin: 'launch',
        });

        // Claim the resurrection gems on backend
        await StateObserver.invoke.claimResurrectionGems();

        // Continue with next action
        return false;
      },
    ],
  }),

  /**
   * Handle 50-gem bear apology resurrection OA message reward.
   */
  actionBlock({
    enabled: ({ user }, now) =>
      hasResurrectionRewardToClaim(user, 'fiftyGemsBear', now),
    actions: [
      async () => {
        // Show reward granting popup
        await openPopupPromise('popupMatch2GrantRewards', {
          rewards: [resurrectionFiftyGemsReward],
          title: 'resurrection.welcomeBack',
          origin: 'launch',
        });

        // Claim the resurrection gems on backend
        await StateObserver.invoke.claimResurrectionFiftyGemsBear();

        // Continue with next action
        return false;
      },
    ],
  }),

  /**
   * Handle 50-gem bear+capybara apology resurrection OA message reward.
   */
  actionBlock({
    enabled: ({ user }, now) =>
      hasResurrectionRewardToClaim(user, 'fiftyGemsBearCapy', now),
    actions: [
      async () => {
        // Show reward granting popup
        await openPopupPromise('popupMatch2GrantRewards', {
          rewards: [resurrectionFiftyGemsReward],
          title: 'resurrection.welcomeBack',
          origin: 'launch',
        });

        // Claim the resurrection gems on backend
        await StateObserver.invoke.claimResurrectionFiftyGemsBearCapy();

        // Continue with next action
        return false;
      },
    ],
  }),

  /**
   * Grant resurrection rewards and continue for Dream Drift or sticker entries.
   */
  async () => {
    // Carry on if the user is not resurrected.
    if (!isReactivated(user(), now())) {
      return false;
    }

    // Show resurrection rewards.
    await openPopupPromise('popupMatch2GrantRewards', {
      rewards: resurrectionRewards,
      title: 'resurrection.welcomeBack',
      origin: 'launch',
    });
    await StateObserver.invoke.grantResurrectionRewards();

    // Continue to the selected OA campaign after granting welcome-back rewards.
    return !isDreamDriftEntry(user()) && !isStickersEntry();
  },

  /**
   * Open the current Dream Drift event when entering from its resurrection OA.
   */
  singleAction({
    enabled: ({ user }) => isDreamDriftEntry(user),
    action: async () => {
      // Use the existing event entry flow, including the locked-player message.
      await dreamDriftOpen('launch');

      // Only an available event replaces the remaining launch sequence.
      return dreamDriftIsAvailable(user(), now());
    },
  }),

  /**
   * Show the sticker campaign for an OA entry or an eligible weekly launch.
   */
  singleAction({
    enabled: ({ user }, now) =>
      isStickersEntry() || canShowStickerPopupOnLaunch(user, now),
    action: async () => {
      // Preserve OA attribution; automatic displays use launch as their source.
      const entry = isStickersEntry()
        ? GCInstant.entryData
        : { feature: 'launch' };
      await openStickersPopup(entry);

      // End launch for reactivated players.
      return isReactivated(user(), now());
    },
  }),

  /**
   * Prompt user to enable notifications
   */
  actionBlock({
    enabled: () =>
      PNsManager.isApiAvailable() &&
      !PNsManager.arePushNotificationEnabledSync(),
    actions: [
      async () => {
        // Check if we should show the permission request popup.
        if (await PNsManager.shouldRemindPermissionRequest()) {
          await PNsManager.requestPermission('launch');
        }
        return false;
      },
    ],
  }),

  // Janken launch sequence: pending results, receiver challenge, event promo.
  ...jankenLaunchSequence,

  /**
   * Handle Add Friends V2 invite flow if user entered via Add Friends V2 invite link.
   * This runs before gifts so users can gift newly added friends immediately.
   */
  singleAction({
    enabled: () => isEnteringFromInviteV2(),
    action: async () => {
      await addFriendsV2LaunchSequence();
      return false;
    },
  }),

  /**
   * Handle in-game friend-request OA — open the confirmation popup with
   * origin: 'launch' when the receiver enters by tapping the OA.
   */
  singleAction({
    enabled: () => isEnteringFromFriendRequest(),
    action: async () => {
      await friendRequestLaunchSequence();
      return false;
    },
  }),

  /**
   * Play Rescue Level launch sequence if enabled.
   */
  singleAction({
    enabled: ({ user }) => rescueLevelIsEnabled(user),
    action: async () => {
      // Run the launch sequence for rescue level
      const willPlay = await rescueLevelLaunch();
      // Skip remaining sequence if user will play the rescue level
      return willPlay;
    },
  }),

  /**
   * Show energy gift popup if there are unclaimed gifts.
   */
  actionBlock({
    skip: ({ user }) =>
      features(user).suppressFeatureIntros || !isGiftsFeatureUnlocked(user),
    actions: [
      async () => {
        const { user } = StateObserver.getState();
        const showGiftsList =
          isFirstEntryOfDay() || hasGiftsMessages(user, now());

        if (!showGiftsList) return false;

        // show the main gift list popup
        const result = await openGiftsListPopup('launch');

        // See sequence above
        if (result === 'invite') {
          wasInviteTriggeredFromGiftsLaunch = true;
        }

        return true;
      },
    ],
  }),

  /**
   * Show friend referral dialog if feature is available and is the first entry of the day.
   * Skip if user already triggered invite from the gifts popup.
   */
  actionBlock({
    skip: ({ user }) =>
      features(user).suppressFeatureIntros ||
      // Skip if the user already triggered an invite from the gifts popup during this launch.
      wasInviteTriggeredFromGiftsLaunch ||
      isPlatformGuest(platform) ||
      !Social.getters.isFriendInviteAvailable(user) ||
      !isFirstEntryOfDay(),
    actions: [
      async () => {
        await startInviteFriendsSequence(
          Feature.INVITE._,
          Feature.INVITE.INVITE_LAUNCH,
        );
        return true;
      },
    ],
  }),

  /**
   * Buddies: process incoming invites and show join rewards for new party members.
   * Suppressed for treatment of A/B 0493 — centralized promo block handles it.
   */
  singleAction({
    enabled: ({ user }, now) =>
      buddiesIsAvailable(user, now) || buddiesIsLocked(user, now),
    action: async () => {
      if (features(user()).suppressFeatureIntros) return false;
      await buddiesLaunchSequence();
      return false;
    },
  }),

  /**
   * Show app install on launch if:
   * - Native promo available
   * - App not installed
   * - Is first entry of day
   */
  actionBlock({
    enabled: ({ user }) =>
      isNativePromoAvailable() &&
      guessInstalledNativeAppPlatform() === null &&
      isFirstEntryOfDay(),
    actions: [
      async () => {
        await startInstallNativeSequence({ originFeature: 'launch' });

        return false;
      },
    ],
  }),

  /**
   * Show level up reward if available.
   */
  actionBlock({
    skip: ({ user: { level } }) => level.current - level.lastLevelReward <= 0,
    actions: [
      async () => {
        await levelUpSequence('launch');

        return true;
      },
    ],
  }),

  /**
   * Show LINE login popup for demo mode users
   */
  actionBlock({
    enabled: ({ user }) =>
      isPlatformGuest(platform) &&
      features(user).isDemoMode &&
      user.tutorial.basicGameplayShown &&
      user.tutorial.chatWithPetsShown,
    actions: [
      async () => {
        await openPopupPromise('popupLineDemoLogin', { origin: 'launch' });

        // Continue with next action.
        return false;
      },
    ],
  }),

  /**
   * Show LINE login popup to guest mode players
   */
  singleAction({
    enabled: () => isPlatformGuest(platform),
    action: async () => {
      if (shouldShowNewPromptLINELoginOnLaunch(user(), now())) {
        await promptLINELoginNew('launchSequence');
      }

      // Continue with next action.
      return false;
    },
  }),

  // Show promotions
  ...promoSequence,

  /**
   * Show duo invitation received sequence.
   */
  actionBlock({
    skip: ({ user }) => !features(user).duo,
    actions: [
      async () => {
        // This promise will resolve as soon as the popup is closed.
        await startDuoInvitationReceivedSequence('launch');

        // We want to wait for any following duo popups to be closed before continuing.
        await duoPopupMutex.lock();
        duoPopupMutex.release();

        return true;
      },
    ],
  }),

  /**
   * Load region assets in background.
   */
  async () => {
    void loadRegionAssets();
    return false;
  },

  /**
   * Launch magic lamps if available.
   */
  singleAction({
    enabled: ({ user }, now) => magicLampsIsAvailable(user, now),
    action: async () => {
      if (features(user()).suppressFeatureIntros) return false;
      await magicLampsLaunch();
      return false;
    },
  }),

  /**
   * Show races popup if applicable.
   */
  singleAction({
    enabled: ({ user }) => areRacesAvailable(user),
    action: async () => {
      if (features(user()).suppressFeatureIntros) return false;
      await openRaceSequence({ auto: true, originFeature: 'launch' });
      return false;
    },
  }),

  /**
   * Claim unclaimed match2 frenzy reward.
   * Will stop the remaining sequence if return true.
   */
  singleAction({
    enabled: ({ user }) => !!user.match2.frenzy.unclaimedMilestone.length,
    action: async () => {
      await match2FrenzyLaunch();
      // Continue with next action.
      return false;
    },
  }),

  /**
   * Show Cards collection first-time intro for control users. Treatment users
   * receive it through the reserved FTUE slot.
   */
  singleAction({
    enabled: ({ user }) => cardsShouldAutoOpenFirstTime(user),
    action: async () => {
      // First-ever discovery belongs to the reserved treatment FTUE slot.
      if (features(user()).suppressFeatureIntros) return false;

      await cardsAutoOpenFirstTime('launch');
      return false;
    },
  }),

  /**
   * Show Match2 Frenzy intro if applicable.
   * Will stop the remaining sequence if return true.
   */
  singleAction({
    enabled: ({ user }, now) => {
      // Skip if match2 frenzy feature is not unlocked.
      if (!isMatch2FrenzyUnlocked(user)) return false;
      // Skip if match2 frenzy feature is not enabled.
      if (!isMatch2FrenzyEnabled(user, now)) return false;
      // Skip if user already saw the match2 frenzy intro.
      if (getMatch2FrenzyIntroLastSeen(user)) return false;
      // Skip if pet is dead.
      if (getCurrentPetState(user, now) === 'dead') return false;
      return true;
    },
    action: async () => {
      if (features(user()).suppressFeatureIntros) return false;
      return await openMatch2FrenzyIntroPopup({
        skipPlay: true,
        setLastOpened: true,
        origin: 'launch',
      });
    },
  }),

  /**
   * Play treasure express launch sequence if available.
   */
  singleAction({
    enabled: ({ user }, now) => isTreasureExpressAvailable(user, now),
    action: async () => {
      if (features(user()).suppressFeatureIntros) return false;
      // Skip remaining sequence if user decided to play from the popup.
      return await treasureExpressLaunch();
    },
  }),

  /**
   * Play super lollipop launch sequence if available.
   */
  singleAction({
    enabled: ({ user }) => isSuperLollipopAvailable(user),
    action: async () => {
      if (features(user()).suppressFeatureIntros) return false;
      // Skip remaining sequence if user decided to play from the popup.
      return await superLollipopLaunch();
    },
  }),

  /**
   * Show streak event popup
   * Will stop the remaining sequence if return true.
   */
  singleAction({
    enabled: ({ user }, now) =>
      // Streak Event is enabled
      isStreakBattleRoyaleEnabled(user) &&
      // and not already active (ie. restarting straight from an expired state)
      !isStreakBattleRoyaleActive(user, now) &&
      // and not already seen the intro (resets alongside the event daily)
      !user.streak?.introSeen,
    action: async () => {
      if (features(user()).suppressFeatureIntros) return false;
      return await openStreakBattleRoyalePopup('launch');
    },
  }),

  /**
   * Show home shortcut launch sequence if applicable
   */
  singleAction({
    enabled: () => isHomeShortcutAvailable(),
    action: async () => {
      if (features(user()).suppressFeatureIntros) return false;
      await homeShortcutLaunchSequence();
      return false;
    },
  }),

  /**
   * Show the weekly Dream Drift introduction for control users. Treatment users
   * receive it through the reserved centralized promo slot.
   */
  singleAction({
    enabled: ({ user }, now) => {
      // Leave the event introduction eligible for a later launch after waking.
      if (getCurrentPetState(user, now) === 'asleep') return false;

      // Preserve the existing event and promo eligibility checks.
      return dreamDriftShouldAutoOpenCurrentEvent(user, now);
    },
    action: async () => {
      // Weekly automatic entry belongs to the reserved treatment promo slot.
      if (features(user()).suppressFeatureIntros) return false;

      // Open the existing FTUE, signup, and map entry flow in order.
      await dreamDriftOpen();
      return false;
    },
  }),

  // Show treatment promo groups after all exempt launch flows.
  ...promoGroupLaunchSequence,

  /**
   * Invoke pet idle sequence if we're entering the living room.
   * Should be the last action in the sequence.
   */
  singleAction({
    enabled: ({ ui }) => ui.transition.nextScene === 'livingRoom',
    action: async () => {
      await statePromise(() => isSceneEntered('livingRoom'));
      await petIdleSequence();
      return true;
    },
  }),
]);
